module.exports = __webpack_public_path__ + "static/img/introducebg01.d6008389.png";